import { Button } from '@mantine/core';
import React from 'react';

import {
  useCreateStoreListing,
  useStoreSettings,
  useUpdateStoreListingPrices,
} from '@portals/api/partners';

import { mapPaymentSettingsToStoreListingPrices } from '../../../utils/store-listings.utils';
import { useStoreListingWizard } from '../hooks';
import { OnCloseCallback } from '../types';

interface SaveDraftButtonProps {
  onClose: OnCloseCallback;
}

export function SaveDraftButton({ onClose }: SaveDraftButtonProps) {
  const { contextData } = useStoreListingWizard();

  const storeSettings = useStoreSettings();
  const createStoreListing = useCreateStoreListing();
  const updateStoreListingPrices = useUpdateStoreListingPrices();

  const isLoading =
    createStoreListing.isLoading || updateStoreListingPrices.isLoading;

  const onClick = async () => {
    if (!contextData.selectedProduct || !storeSettings.data) return;

    const prices = mapPaymentSettingsToStoreListingPrices({
      pricingModel: contextData.selectedProduct.pricing_model,
      currencies: storeSettings.data.currencies,
      paymentSettings: contextData.paymentSettings,
    });

    try {
      if (contextData.storeListing) {
        await updateStoreListingPrices.mutateAsync({
          storeListingId: contextData.storeListing.id,
          prices,
        });
      } else {
        await createStoreListing.mutateAsync({
          productId: contextData.selectedProduct.id,
          prices,
        });
      }

      onClose({ confirmBeforeClose: false });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Button variant="default" loading={isLoading} onClick={onClick}>
      Save as Draft
    </Button>
  );
}
